export const ReflectionActionsEnum = {
    CRUD: 1,
    View: 2,
    Report: 3
}